import React from "react";

export let AreaView = ({name}) => {
  return <span className="area">
    &nbsp;{name}
  </span>
};

